import * as React from "react";
import { SvgComponentProps } from "utils/types/app";

const CheckSvgComponent: React.FC<SvgComponentProps> = (props) => {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_2769_2613)">
        <path
          d="M4.3 11.25l-.95-1.6-1.8-.4.175-1.85L.5 6l1.225-1.4-.175-1.85 1.8-.4.95-1.6 1.7.725L7.7.75l.95 1.6 1.8.4-.175 1.85L11.5 6l-1.225 1.4.175 1.85-1.8.4-.95 1.6-1.7-.725-1.7.725zm1.175-3.475L8.3 4.95l-.7-.725L5.475 6.35 4.4 5.3l-.7.7 1.775 1.775z"
          fill="#699BF7"
        />
      </g>
      <defs>
        <clipPath id="clip0_2769_2613">
          <path
            fill="#fff"
            d="M0 0H12V12H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckSvgComponent;
